enum ReportType {
  Standard = 0,
  GoodManufacturingPractice = 1
}

export default ReportType;
